import { all, call, put, select, takeEvery, takeLatest } from "redux-saga/effects";

import { TicketsRoutes, getPathForRoute } from "constants/tickets/TicketsRoutes";
import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { pushWithUTM } from "helpers/sagas";
import { ApiManager } from "services/api";
import CustomViewSerializer from "services/api/customView/CustomViewSerializer";
import {
  IEntityCreateFailure,
  IEntityCreateSuccess,
  IEntityDelete,
  IEntityFetch,
  IEntityUpdate,
} from "store/entities/actions";
import { CustomViewsActions, CustomViewsActionsNames } from "store/entities/custom-views/actions";
import { ICustomView } from "store/entities/custom-views/interfaces";
import { SessionActions, selectTransientFlag } from "store/features/session";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";
import { TicketsViewActions } from "store/views/tickets/actions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingle(action: IActionWithPayload<string, IEntityFetch>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const viewResponse = yield call(ApiManager.customViewApi.fetch, action.payload.id as string);
  if (viewResponse.result) {
    const view = CustomViewSerializer.deserialize(viewResponse.result);
    yield put(CustomViewsActions.fetchSuccess({ id, value: view }));
  } else {
    yield put(CustomViewsActions.fetchFailure({ id, error: "Not found" }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const viewsResponse = yield call(ApiManager.customViewApi.fetchAll);

  if (viewsResponse.result) {
    yield put(
      CustomViewsActions.fetchCollectionSuccess({
        values: CustomViewSerializer.deserializeCollection(viewsResponse.result),
      })
    );
  } else {
    yield put(CustomViewsActions.fetchCollectionFailure({ error: viewsResponse.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createCustomView(action: IActionWithPayload<string, IEntityUpdate<ICustomView>>) {
  const customView = action.payload.value;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.customViewApi.create, customView);

  if (response.result) {
    const createdCustomView = CustomViewSerializer.deserialize(response.result);
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const tooltipShown = yield select(selectTransientFlag("customViewTooltipToggled"));
    yield put(CustomViewsActions.createSuccess({ id: createdCustomView.id, value: createdCustomView }));
    if (tooltipShown) {
      trackEngagement("Save view: View created after tooltip shown", EventPlace.Tickets);
      yield put(SessionActions.setTransientFlag("customViewTooltipToggled", false));
    }
  } else {
    const errorObject = response.error.error;
    yield put(CustomViewsActions.createFailure({ error: errorObject.message, errorObject }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* createCustomViewSuccess(action: IActionWithPayload<string, IEntityCreateSuccess<ICustomView>>) {
  const customView = action.payload.value;
  yield put(pushWithUTM(getPathForRoute(TicketsRoutes.All)));
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  yield put(TicketsViewActions.selectCustomView({ id: customView.id }));
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_VIEW_CREATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* createCustomViewFailure(action: IActionWithPayload<string, IEntityCreateFailure>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_VIEW_CREATE_FAILURE, action.payload),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateCustomView(action: IActionWithPayload<string, IEntityUpdate<ICustomView>>) {
  const customView = action.payload.value;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.customViewApi.update, customView);

  if (response.result) {
    const updatedCustomView = CustomViewSerializer.deserialize(response.result);
    yield put(CustomViewsActions.updateSuccess({ id: updatedCustomView.id, value: updatedCustomView }));
  } else {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(CustomViewsActions.updateFailure({ id: customView.id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'action' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
export function* updateCustomViewSuccess(action: IActionWithPayload<string, ICustomView>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_VIEW_UPDATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* updateCustomViewFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_VIEW_UPDATE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteCustomView(action: IActionWithPayload<string, IEntityDelete>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.customViewApi.deleteCustomView, id);

  if (response.result) {
    yield put(CustomViewsActions.deleteSuccess({ id }));
  } else {
    yield put(CustomViewsActions.deleteFailure({ id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* deleteCustomViewSuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_VIEW_DELETE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* deleteCustomViewFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_VIEW_DELETE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* viewsSagas() {
  yield all([
    takeLatest(CustomViewsActionsNames.FETCH_SINGLE.REQUEST, fetchSingle),
    takeLatest(CustomViewsActionsNames.FETCH_COLLECTION.REQUEST, fetchCollection),
    takeEvery(CustomViewsActionsNames.CREATE.REQUEST, createCustomView),
    takeEvery(CustomViewsActionsNames.CREATE.SUCCESS, createCustomViewSuccess),
    takeEvery(CustomViewsActionsNames.CREATE.FAILURE, createCustomViewFailure),
    takeEvery(CustomViewsActionsNames.UPDATE.REQUEST, updateCustomView),
    takeEvery(CustomViewsActionsNames.UPDATE.SUCCESS, updateCustomViewSuccess),
    takeEvery(CustomViewsActionsNames.UPDATE.FAILURE, updateCustomViewFailure),
    takeEvery(CustomViewsActionsNames.DELETE.REQUEST, deleteCustomView),
    takeEvery(CustomViewsActionsNames.DELETE.SUCCESS, deleteCustomViewSuccess),
    takeEvery(CustomViewsActionsNames.DELETE.FAILURE, deleteCustomViewFailure),
  ]);
}
